<template>
  <div>
    <v-container fluid grid-list-xl class="margin-top-50px">
      <v-form class="margin-top-40px">
        <v-layout row wrap>
          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-text-field
              v-model="body.agent.name"
              :rules="nameRules"
              solo
              placeholder="نام و نام خانوادگی"
              hint="فقط حروف فارسی پشتیبانی میشود"
              append-icon="account_circle"
              clearable
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-text-field
              v-model="body.agent.phone"
              :rules="userTelRules"
              mask="phone"
              solo
              class="text-xs-left"
              prepend-inner-icon="call"
              style="direction: ltr"
              prefix="+98"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-text-field
              v-model="body.agent.email"
              solo
              placeholder="پست الکترونیکی "
              class="ltr"
              mask
              hint="yourname@example.com"
              append-icon="email"
              clearable
              :rules="userEmailRules"
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-text-field
              solo
              placeholder="نام کاربری"
              v-model="body.agent.username"
              class="ltr"
              append-icon="verified_user"
              clearable
              hint="نام کاربری باید فقط شامل حروف و اعداد انگلیسی باشد"
              required
              :rules="userNameRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-text-field
              solo
              v-model="body.agent.password"
              placeholder="رمز عبور"
              class="ltr"
              append-icon="verified_user"
              clearable
              hint="رمز عبور باید فقط شامل حروف و اعداد انگلیسی باشد"
              required
              :rules="userNameRules"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6 md6 xl4 lg4 style="margin-top:-25px">
            <v-flex lg6 style="margin-right:65px">
              <date-picker v-model="body.race.startDate" placeholder="تاریخ شروع مسابقه"></date-picker>
            </v-flex>
            <v-flex lg6 style="margin-right:65px">
              <date-picker v-date="endDate" placeholder="تاریخ پایان مسابقه"></date-picker>
            </v-flex>
          </v-flex>

          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-text-field
            v-model="body.race.name"
              :rules="nameRules"
              solo
              placeholder="نام مسابقه"
              hint="فقط حروف فارسی پشتیبانی میشود"
              append-icon="account_circle"
              clearable
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-select
              v-model="raceCategory"
              solo
              append-icon="category"
              :items="raceType"
              placeholder="نوع مسابقه را انتخاب کنید"
            ></v-select>
          </v-flex>

          <v-flex xs12 sm6 md6 xl4 lg4 style="margin-top:-25px">
            <v-flex lg6 style="margin-right:65px">
              <date-picker placeholder="تاریخ شروع ثبت نام"></date-picker>
            </v-flex>
            <v-flex lg6 style="margin-right:65px">
              <date-picker placeholder="تاریخ پایان ثبت نام"></date-picker>
            </v-flex>
          </v-flex>

          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-text-field
              v-model="body.race.totalCapacityCount"
              solo
              placeholder="ظرفیت را وارد کنید"
              type="number"
              append-icon="people"
              clearable
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6 md6 xl4 lg8>
            <v-btn
              block
              color="indigo"
              class="bt"
              dark
              :loading="userRegisterLoading"
              @click="create()"
            >
              <v-icon>done</v-icon>ثبت
            </v-btn>
            <div class="danger-alert" v-if="error">{{error}}</div>
          </v-flex>
        </v-layout>
      </v-form>
    </v-container>
  </div>
</template>

<script>
// eslint-disable-next-line
/* eslint-disable */
import axios from "axios";

import RaceServices from "@/services/RaceServices";
export default {
  data() {
    return {
      error: null,
      enabledUsers: [],
      body: [],
      agent: {},
      body: {
        race: {
          name: null,
          city: {
            id: 2,
            name: "تهران"
          },
          totalCapacityCount: null,
          raceCategory: null,
          startDate: null,
          endDate: null
        },
        agent: {
          name: null,
          username: null,
          password: null,
          email: null,
          phone: null
        }
      },
      NSUFvalid: false,
      userRegisterLoading: false,
      userDataTableLoading: false,
      userDeletedDataTableLoading: true,
      UserTableDeletedItem: [],
      confirmRecovery: false,
      idRules: [v => !!v || " شماره شناسنامه ضروری است"],
      nationalCodeRules: [
        v => !!v || "کد ملی فیلد ضروری است",
        v => (v && v.length == 10) || "کد ملی باید ده رقمی باشد"
      ],
      numRules: [v => !!v || "این فیلد ضروری است"],
      ncRules: [
        v => !!v || "این فیلد ضروری است",
        v => (v && v.length >= 3) || "حداقل 3 رقم"
      ],
      nameRules: [
        v => !!v || "نام و نام خانوادگی الزامی میباشد",
        v => (v && v.length >= 3) || "حداقل 3 کاراکتر"
      ],
      nameclass: [
        v => !!v || "کلاس مورد نظر را مشخص کنید",
        v => (v && v.length >= 3) || "حداقل 3 کاراکتر"
      ],
      userTelRules: [
        v => !!v || "تلفن همراه الزامی میباشد",
        v => (v && v.length == 10) || "تلفن همراه وارد شده صحیح نمیباشد"
      ],
      userEmailRules: [
        v => !!v || "پست الکترونیکی الزامی میباشد",
        v => /.+@.+/.test(v) || "پست الکترونیکی وارد شده صحیح نمیباشد"
      ],
      userNameRules: [
        v => !!v || "نام کاربری الزامی میباشد",
        v => (v && v.length >= 5) || "نام کاربری باید حد اقل 5 کاراکتر باشد",
        v => /[A-Za-z&0-9]/.test(v) || "نام کاربری وارد شده صحیح نمیباشد"
      ],
      userPermissionRules: [v => !!v || "تعیین دسترسی های کاربر الزامی میباشد"],
      raceCategory: []
    };
  },
  methods: {
    // onFileChanged(event) {
    //   this.User.image = event.target.files[0];
    // },
    // async getAllEnabled() {
    //   this.enabledUsers = (await AgentService.index()).data;
    // },
    async create() {
      let res;
      var msg = "";
      this.error = null;
      // const areAllFieldsFilledIn = Object.keys(this.User).every(
      //   key => !!this.User[key]
      // );
      // if (!areAllFieldsFilledIn) {
      //   this.error = "لطفا تمامی فیلد هارا پر کنید";
      //   return;
      // }
      try {
        console.log(this.body)
        let res;
        res = await RaceServices.post(this.body);
        console.log(res);
        if (res == 1) {
          msg = "=>DONE";
        } else if (res == 0) {
          msg = "=>FAILED";
        }
        console.log(msg);
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style scoped>
.danger-alert {
  color: red;
}
.margin-top-50px {
  margin-top: 50px;
}
.bt {
  height: 48px;
  margin: 0;
  width: 100%;
}
</style>
